import { Button, Card, CardContent, CardHeader, Grid, LinearProgress, TextField, Typography } from '@material-ui/core';
import { DataGrid,GridColDef as ColDef } from '@material-ui/data-grid';
import React, { Fragment, useEffect, useState } from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { ApiBackend } from '../../providers/apibackend';
import * as XLSX from 'xlsx';
import { FisCode } from '../../model/FisCode';
import AddFisCode from './AddFisCode';

const ManageFisCodes = () => {
   

    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');
    const [fisCodes, setFisCodes] = useState([] as FisCode[]);
    const [displayFisCodes, setDisplayFisCodes] = useState([] as FisCode[]);
    const [toImport, setToImport] = useState([] as FisCode[]);
    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        let api = new ApiBackend();
        api.listFisCodes().then((codes) => {
            setFisCodes(codes);
        });
    },[]);

    useEffect(() => {
        if (filter)
        {
            setDisplayFisCodes(fisCodes.filter(x=>(x.firstName && x.firstName.toLowerCase().startsWith(filter.toLowerCase())) || (x.lastName && x.lastName.toLowerCase().startsWith(filter.toLowerCase())) || (x.club && x.club.toLowerCase().startsWith(filter.toLowerCase()))||x.fisCode + "" == filter));
        }
        else 
        {
            setDisplayFisCodes(fisCodes);
        }
    },[fisCodes, filter])

     const columns: ColDef[] = [
                {
                    field: 'fisCode', headerName: 'FIS-kod', minWidth: 300, flex: 0.2
                },
                { field: 'firstName', headerName: 'Förnamn.', width: 150 },
                { field: 'lastName', headerName: 'Efternamn', minWidth: 250 },
                { field: 'club', headerName: 'Klubb', minWidth: 250 },
                { field: 'points', headerName: 'DI-poäng', minWidth: 250 }
            ];

    const parseXLSX = (data : string) => {
            let readedData = XLSX.read(data, {type: 'binary', cellDates:true, cellText: false});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, {header:1, raw: false, dateNF: 'yyyy-mm-dd'}) as string[][];
        let columns = dataParse[0];
        let rows = dataParse.slice(1);

          setLoading(false);

           if (columns.indexOf("Listid") < 0)
        {
            alert("No Listid in file")
            return;
        }
        if (columns.indexOf("Fiscode") < 0)
        {
            alert("No fiscode in file")
            return;
        }
        if (columns.indexOf("Firstname") < 0)
        {
            alert("No firstname in file")
            return;
        }
        if (columns.indexOf("Lastname") < 0)
        {
            alert("No lastname in file")
              return;
        }
         if (columns.indexOf("Skiclub") < 0)
         {
            alert("No skiclub in file")
              return;
        }
          if (columns.indexOf("DIpoints") < 0)
          {
            alert("No DIpoints in file")
              return;
        }

        const idxListId = columns.indexOf("Listid");
        const idxFisCode = columns.indexOf("Fiscode");
        const idxFirstName = columns.indexOf("Firstname");
        const idxLastName = columns.indexOf("Lastname");
        const idxSkiClub = columns.indexOf("Skiclub");
        const idxPoints = columns.indexOf("DIpoints");

        setToImport(rows.map((row) => {
            return {
                listId : +row[idxListId],
                fisCode : +row[idxFisCode],
                firstName : row[idxFirstName],
                    lastName: row[idxLastName],
                    club: row[idxSkiClub],
                    points: +row[idxPoints]
            } as FisCode
        }));

      
    };
    
    return <>
    {showAdd && <AddFisCode close={() => {setShowAdd(false)}} add={async (code) => { 
        let api = new ApiBackend();
        let res = await api.addFisCode(code);
        if (!res)
        {
            alert("Fel vid sparande!?!");
        }
        
        let codes = await api.listFisCodes();
        setFisCodes(codes);
        setShowAdd(false);
    }}/>}
    <Grid container spacing={2}>
         <Grid item xs={12}>
                <Card>
                    <CardHeader title={<Fragment><Typography variant="h5" style={{ display: 'inline' }}>Importera </Typography></Fragment>} />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                                onChange={(ev) => {
                                        setLoading(true);
                                                let file = ev.target.files[0];
                                                const reader = new FileReader();
                                                reader.addEventListener('load', (event) => {
                                                        parseXLSX(event.target.result as string)                    
                                                });
                                                reader.readAsBinaryString(file)
                                    }
                                }
                                />
                             
                                <Button variant="contained" disabled={!toImport || toImport.length == 0} onClick={async()=>{
                                    let api = new ApiBackend();
                                    setLoading(true);
                                    let resp = await api.importFisCodes(toImport);
                                    setLoading(false);

                                    if (resp)
                                    {
                                        alert("Import lyckades!");
                                        setToImport(null);
                                    }
                                    else 
                                    {
                                        alert("Import misslyckades?!?");
                                    }

                                    let codes = await api.listFisCodes();
                                    setFisCodes(codes);
                                }}>Importera</Button>
                             </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <CardHeader title={<Fragment><Typography variant="h5" style={{ display: 'inline' }}>Filtrera </Typography></Fragment>} />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField label="Filter" value={filter} onChange={(ev) => {setFilter(ev.target.value);}} fullWidth/>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12}>
                <Card>
                    <CardHeader title={<Fragment><Typography variant="h5" style={{ display: 'inline' }}>Fiskoder </Typography>
                        <AddCircleIcon style={{ display: 'inline', cursor: 'pointer', verticalAlign: 'middle' }} onClick={() => {setShowAdd(true)}} /></Fragment>} />
                    <CardContent>
                        {loading &&
                            <LinearProgress color="secondary" />
                        }
                        <div style={{ height: 400, width: '100%' }}>
                            <DataGrid getRowId={(row) => row.fisCode}  loading={loading} rows={displayFisCodes ?? []} columns={columns} pageSize={100} rowsPerPageOptions={[100]} />
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    </>;
}

export default ManageFisCodes;